import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-size: 1rem;\n  min-height: 48px;\n  padding: 12px 16px;\n  white-space: nowrap;\n\n  :hover,\n  :focus {\n    background: ", ";\n  }\n\n  /* Selected option styles are contained in SelectListbox */\n\n  ", "\n\n  > svg {\n    align-self: center;\n    margin-right: 16px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 0.875rem;\n  line-height: 1.25;\n  margin-left: auto;\n  margin-top: 4px;\n  white-space: normal; /* Needed to override Option style */\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useContext } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import SelectContext from './SelectContext';
import { whiteSmoke, steel } from '../../styles/colors';
import { handleKeyboardClick } from '../../utils';
import useId from '../../hooks/useId';
var SupportingText = styled.div(_templateObject(), steel);
var Option = styled.div(_templateObject2(), whiteSmoke, function (props) {
  return props.singleLine && "\n      align-items: baseline;\n      display: flex;\n      flex-wrap: nowrap;\n\n      ".concat(SupportingText, " {\n        padding-left: 1rem;\n      }\n    ");
});
export default function SelectOption(_ref) {
  var children = _ref.children,
      value = _ref.value,
      id = _ref.id,
      props = _objectWithoutProperties(_ref, ["children", "value", "id"]);

  var _useContext = useContext(SelectContext),
      selectedValue = _useContext.value,
      onClick = _useContext.onClick;

  var generatedId = useId(id);

  var onOptionClick = function onOptionClick(e) {
    e.target.value = value;
    onClick(e);
  };

  var onOptionKeyboardClick = handleKeyboardClick(onOptionClick);
  return React.createElement(Option, _extends({}, props, {
    "data-value": value,
    role: "option",
    "aria-selected": value === selectedValue,
    onClick: onOptionClick,
    onKeyPress: onOptionKeyboardClick,
    id: generatedId
  }), children);
}
SelectOption.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  singleLine: PropTypes.bool,
  id: PropTypes.string
};
SelectOption.defaultProps = {
  singleLine: false,
  id: ''
};
SelectOption.SupportingText = SupportingText;